import React from 'react';
import PropTypes from 'prop-types';

import StyledAriaTooltip from './styled';

const DEF_FORMATTER = value => value;
const AriaTooltip = ({ active, payload, formatter = DEF_FORMATTER }) => {
  const data = payload?.[0]?.payload;
  if (active && data) {
    return data?.tooltip ? <StyledAriaTooltip>{formatter(data.tooltip)}</StyledAriaTooltip> : null;
  }

  return null;
};

AriaTooltip.propTypes = {
  active: PropTypes.bool,
  formatter: PropTypes.func
};

export default AriaTooltip;
